<template>
  <div class="p-5 bg-white shadow overflow-hidden sm:rounded-lg w-full sm:mt-6">
    <div class="space-y-8 divide-y divide-gray-200">
      <div class="space-y-8 divide-y divide-gray-200">
        <div>
          <div>
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Settings
            </h3>
            <p class="mt-1 text-sm text-gray-500">
              This information will be available to every person you are linked with.
            </p>
          </div>
          <div class="rounded-md bg-red-050 p-4 mt-3" v-if="error">
            <div class="flex">
              <div class="flex-shrink-0">
                <!-- Heroicon name: solid/x-circle -->
                <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                </svg>
              </div>
              <div class="ml-3">
                <h3 class="text-sm font-medium text-red-800">
                  There were errors with your submission
                </h3>
                <div class="mt-2 text-sm text-red-700">
                  <ul class="list-disc pl-5 space-y-1">
                    <li>
                      {{error.message}}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-2">
              <label for="city" class="block text-sm font-medium text-gray-700">
                First Name
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  name="city"
                  id="city"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  v-model="user.firstname"
                />
              </div>
            </div>
            <div class="sm:col-span-2">
              <label for="city" class="block text-sm font-medium text-gray-700">
                Last Name
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  name="city"
                  id="city"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  v-model="user.lastname"
                />
              </div>
            </div>
            <div class="sm:col-span-4">
              <label for="city" class="block text-sm font-medium text-gray-700">
                Email
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  name="city"
                  id="city"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  v-model="user.email"
                />
              </div>
            </div>
                        <div class="sm:col-span-2">
              <label for="city" class="block text-sm font-medium text-gray-700">
                Phone
              </label>
              <div class="mt-1">
                <input
                  type="text"
                  name="city"
                  id="city"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                  v-model="user.phonenumber"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pt-5">
        <div class="flex justify-end">
          <button
            type="button"
            @click="resetPassword()"
            class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Reset password
          </button>
          <button
            @click="update()"
            class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Settings",
  components: {},
  data() {
    return {
      error: null
    };
  },
  computed: {
    ...mapGetters("user", {
      user: "currentUser",
    }),
  },
  methods: {
    resetPassword() {
      this.$store.dispatch("user/requestPassword", {
        email: this.user.email,
      });
      this.$store.dispatch("user/logoutUser");
    },
    update() {
      if(
        this.user.firstname.length < 3 ||
        this.user.lastname.length < 3 ||
        this.user.email.length < 3 ||
        this.user.phonenumber.length < 8
      ){
        this.error = {
          type: 'validation',
          message: 'Please make sure your email, first name and lastname are longer than 3 characters. Your phone number must be at least 8 characters.'
        }
        return
      }
      this.$store.dispatch("user/updateUser", {
        firstname: this.user.firstname,
        lastname: this.user.lastname,
        phonenumber: this.user.phonenumber,
        email: this.user.email,
      });
    },
  },
};
</script>